import loadId from "./loadId";
export const REQUEST_SOURCE_HEADER = 'X-Request-Source';
export function getRequestSourceInformation({ service, project, component, operation }) {
    return {
        service: service !== null && service !== void 0 ? service : '<unknown>',
        project: project !== null && project !== void 0 ? project : '<unknown>',
        operation: operation !== null && operation !== void 0 ? operation : '<unknown>',
        component: component !== null && component !== void 0 ? component : '<unknown>'
    };
}
export function getRequestSourceHeader(info) {
    const parts = [];
    for(const name in info){
        if (info.hasOwnProperty(name)) {
            const value = info[name];
            const cleanValue = value.replace(/[^\x20-\x7E]/g, '?');
            parts.push(`${name}=${JSON.stringify(cleanValue)}`);
        }
    }
    return parts.concat(`load_id="${loadId}"`).join('; ');
}

//# sourceMappingURL=requestSource.js.map